// Generated code for Big.Entities.ActiviteitType.
// Edit _Enum.tst to change the generated output.

export enum ActiviteitType {
    onbekend = 0,
    afhandelenAanvraagFormulier = 1,
    bepalenSoortAfhandeling = 2,
    registrerenAanvraagArtikel3EnArtikel34 = 3,
    registrerenAanvraagVerklaringVakbekwaamheid = 4,
    controlerenAanvraagOpCompleetheid = 5,
    opschortenAanvraag = 6,
    registrerenAanvullendeInformatie = 7,
    beoordelenInhoudAanvraag = 8,
    opstellenVerzoekNadereToelichting = 9,
    registrerenNadereToelichting = 10,
    registrerenOordeelEchtheidDiplomas = 11,
    opstellenBriefEchtheidDiplomas = 12,
    bepalenAfhandelingVakbekwaamheid = 13,
    registrerenUitkomstTandemOverleg = 14,
    opstellenBriefDiplomaWaardering = 15,
    registrerenDiplomaWaardering = 16,
    opstellenBeschikking = 17,
    toetsenBeschikking = 18,
    opstellenVoorgenomenBesluit = 19,
    toetsenVoorgenomenBesluit = 20,
    registrerenReactieOpZienswijze = 21,
    opstellenVerslagZienswijzeGesprek = 22,
    opstellenUitnodigingVoorZienswijzeGesprek = 23,
    opstellenBriefAntwoordOpReactieZienswijze = 24,
    beoordelenInBehandelingNemenAanvraag = 25,
    beoordelenUitkomstCbgv = 26,
    verifiërenDiplomas = 27,
    opstellenUitstelBrief = 28,
    bepalenAfhandelingCommissie = 29,
    registrerenTelefonischVerzoek = 30,
    opstellenBriefAanmeldingAkvToetsCbgv = 31,
    opstellenBriefInformatieAkvToetsEnPortfolioCbgv = 32,
    registrerenDatumVanZitting = 33,
    registrerenBezwaarBeroepHogerBeroepOfOverigeKlacht = 34,
    opstellenBemiddelingsbrief = 35,
    opstellenVerweerschrift = 36,
    bepalenWijzeRappelleren = 37,
    opstellenRappelbriefInstelling = 38,
    opstellenRappelbriefBetaling = 39,
    registrerenFraudecontrole = 40,
    toetsenUitstelBrief = 41,
    opstellenBevestigingAfbrekenLopendeAanvraag = 42,
    aanmakenMachtiging = 43,
    opstellenPleitnota = 44,
    registrerenAfspraakAkvToetsCbgv = 45,
    opstellenBriefMeldingDatumAkvToetsCbgv = 46,
    registrerenUitslagAkvToetsCbgv = 47,
    automatischVerwerkenBetalingen = 48,
    handmatigVerwerkenBetalingen = 49,
    registrerenVerzoekUitstel = 50,
    rappelleringDoorZorro = 51,
    registrerenSupervisieproces = 52,
    registrerenVerzoekVerlengingSupervisie = 53,
    verlengenSupervisie = 54,
    registrerenOntvangstSupervisieverklaring = 55,
    omzettenInschrijvingNaarOngeclausuleerd = 56,
    registrerenOntvangstSupervisieovereenkomst = 57,
    registrerenOntvangstBeoordelingsformulier = 58,
    opstellenOntvangstBevestigingBeoordelingsformulier = 59,
    registrerenAfbrekenLopendeZaak = 60,
    opstellenBriefAanvullendeInformatieCbgv = 61,
    registrerenAanvullendeInformatieCbgv = 62,
    opstellenBriefAkvToetsNietBehaald = 63,
    voorbereidenSchriftelijkeRondeCbgv = 64,
    voorbereidenVergaderingCbgv = 65,
    registrerenPreAdviesCbgv = 66,
    opstellenBriefOverdragenAanCommissieCbgv = 67,
    registrerenVergaderingCbgv = 68,
    opstellenBriefAfspraakAanvullendGesprekCbgv = 69,
    registrerenDatumAanvullendGesprekCbgv = 70,
    opstellenVerslagAanvullendGesprekCbgv = 71,
    opstellenAdviesCbgv = 72,
    toetsenAdviesCbgv = 73,
    registrerenOndertekeningAdviesCbgv = 74,
    uitvoerenBeleidstoetsOpAdvies = 75,
    koppelenDocumentAanZaak = 76,
    registrerenReactieOpBemiddelingsbrief = 77,
    opstellenVerslagBemiddelingsgesprek = 78,
    registrerenAfwikkelingBezwaarschrift = 79,
    opstellenAanvullendVerweerschrift = 80,
    registrerenAdviesOfUitspraak = 81,
    registrerenOntvangstConceptBeslissingDwjz = 82,
    registrerenVerzoekOpstellenOverwegingen = 83,
    opstellenInhoudelijkeOverwegingen = 84,
    registrerenOntvangstBeslissingDwjz = 85,
    automatischInitierenZaakDoorhaling = 86,
    registrerenDoorhaling = 87,
    opstellenBeschikkingDoorhaling = 88,
    toetsenBeschikkingDoorhaling = 89,
    opstellenBerichtgevingAanDerden = 90,
    toetsenBerichtgevingAanDerden = 91,
    opstellenPublicatieStaatscourantEnKrant = 92,
    toetsenPublicatieStaatscourantEnKrant = 93,
    bepalenVervolgstapBezwaarEnBeroep = 94,
    registrerenReactieVanBezwaarcommissie = 95,
    registrerenErkenningOfIntrekkingSpecialisme = 96,
    opstellenBeschikkingSpecialisme = 97,
    toetsenBeschikkingSpecialisme = 98,
    opTeStellenBriefAanbiedenMedischInhoudelijkeToetsCbgv = 99,
    registrerenSchriftelijkVerzoek = 100,
    beantwoordenStandaardSchriftelijkVerzoek = 101,
    bepalenBeantwoorderVerzoek = 102,
    beantwoordenNietStandaardSchriftelijkVerzoek = 103,
    beantwoordenSchriftelijkVerzoekStaf = 104,
    toetsenNietStandaardAntwoord = 105,
    bepalenVervolgstapMedischInhoudelijkeToetsCbgv = 106,
    registrerenUitspraakArtikelregistratie = 107,
    opstellenBeslissingBevoegdheidsbeperking = 108,
    toetsenBeslissingBevoegdheidsbeperking = 109,
    registrerenReactieOpUitspraakArtikel3 = 110,
    opstellenBriefAanmeldingMedischInhoudelijkeToetsCbgv = 111,
    registrerenAfspraakMedischInhoudelijkeToetsCbgv = 112,
    opstellenMeldingDatumMedischInhoudelijkeToetsCbgv = 113,
    registrerenUitslagMedischInhoudelijkeToetsCbgv = 114,
    registrerenBeoordelingsformulierenCbgv = 115,
    opstellenBriefAfspraakAdviesgesprekAssessmentCbgv = 116,
    opstellenDiscussiepuntenlijstCbgv = 117,
    opstellenVerslagAdviesgesprekCbgv = 118,
    bepalenVervolgstapBeoordelenAsessmentCbgv = 119,
    registrerenReactieDatumAdviesgesprekAssessmentCbgv = 120,
    wijzigenStatusVanDeZaak = 121,
    verwijderenLockVanEenZaak = 122,
    wijzigenGegevensZorgverlener = 123,
    bepalenUitstelVanBehandelingRibiz = 124,
    opstellenBriefUitstelVanBehandelingRibiz = 125,
    toetsenBriefUitstelVanBehandelingRibiz = 126,
    bepalenVervolgstapAkvToetsCbgv = 127,
    conversie = 128,
    automatischInitierenZaakSpecialisme = 129,
    verwijderenZorgverlener = 130,
    ontdubbelenZorgverlener = 131,
    scannenDocumenten = 132,
    automatischGenererenBriefNabestaanden = 133,
    diplomaToetsenVoorUziPas = 134,
    koppelenDiplomaUziRegister = 135,
    beoordelenDiplomaUziRegister = 136,
    afhandelenAanvraagFormulierViaWebsite = 137,
    toevoegenBetalingViaWebsite = 138,
    verwijderenSpecialisme = 139,
    loskoppelenDocumentBijZaak = 140,
    opstellenRappelbriefAanvraagformulier = 141,
    registerenAanvraagVerklaring = 142,
    opstellenVerklaring = 143,
    toetsenVerklaring = 144,
    opstellenKopieVerklaring = 145,
    opTeStellenBriefInformatieProcedureAanvrager = 146,
    opTeStellenBriefInformatieProcedureAanvragerCbgv = 147,
    bepalenRouteCommissieCbgv = 148,
    verwijderenDocumentBijZaak = 149,
    opstellenIntrekkingMaatregelOfBevel = 150,
    toetsenIntrekkingMaatregelOfBevel = 151,
    afhandelenVerzoekAanvraagformulierVermeldingOfHerregistratie = 152,
    registrerenVermelding = 153,
    aanschrijvenHerregistratie = 154,
    rappelerenHerregistratie = 155,
    aanvragenHerregistratieViaWebsite = 157,
    rappellerenBetalingHerregistratie = 158,
    automatischAfhandelen = 159,
    rappellerenAanvullendeInformatie = 160,
    besluitHerregistratieNegatiefOfNib = 161,
    terugbetalenHerregistratie = 162,
    automatischDoorhalenRegistratie = 163,
    registrerenAanvraagHerregistratie = 164,
    beherenUitersteHerregistratiedatum = 165,
    opstellenBriefInformatieProcedureAanvragerNaAkvToets = 166,
    opstellenProcedurebriefAanvragerVoorleggenAanImi = 167,
    registrerenReactieImi = 169,
    aanvraagVerklaringViaWebsite = 170,
    indienenAanvraagBigLogin = 171,
    activerenBigLogin = 172,
    inloggenMetBigLogin = 173,
    wijzigenWachtwoord = 174,
    indienenAanvraagNieuwWachtwoord = 175,
    invullenNieuwWachtwoord = 176,
    afhandelenVerzoekNieuwWachtwoord = 177,
    automatischInitierenZaakRechterlijkeUitspraak = 178,
    opstellenBriefOverdragenAanMinister = 179,
    toetsenOpschorting = 180,
    registrerenDocumentBijZaak = 181,
    automatischDoorhalenRegistratieGeenReactieOpAanschrijving = 182,
    opstellenBriefInformatieNuffic = 183,
    registrerenOntvangstDiplomaBijNuffic = 184,
    automatischOmzettenSpecialisme = 185,
    afmeldenHerregistratieViaWebsite = 186,
    uitschrijvenBigRegisterViaWebsite = 187,
    automatischOpstellenBeschikkingDoorhalingEigenVerzoek = 188,
    automatischOpstellenPositieveBeschikking = 189
}
(ActiviteitType as any).name = 'ActiviteitType';
